import * as types from './constants'

export const recoverPassword = (payload) => ({
  type: types.RECOVER_PASSWORD,
  payload
})

export const recoverPasswordSuccessful = recoverData => ({
  type: types.RECOVER_PASSWORD_SUCCESSFUL,
  payload: recoverData
})

export const recoverPasswordFailure = error => ({
  type: types.RECOVER_PASSWORD_FAILURE,
  payload: error
})

export const resetPassword = payload => ({
  type: types.RESET_PASSWORD,
  payload
})

export const changeTemporaryPassword = payload => ({
  type: types.CHANGE_TEMPORARY_PASSWORD,
  payload
})
export const changeTemporaryPasswordSuccess = payload => ({
  type: types.CHANGE_TEMPORARY_PASSWORD_SUCCESS,
  payload
})
export const changeTemporaryPasswordFailure = payload => ({
  type: types.CHANGE_TEMPORARY_PASSWORD_FAILURE,
  payload
})

export const resetPasswordSuccessful = user => ({
  type: types.RESET_PASSWORD_SUCCESSFUL,
  payload: user
})

export const resetPasswordFailure = error => ({
  type: types.RESET_PASSWORD_FAILURE,
  payload: error
})
